/** @jsxImportSource @emotion/react */
import React from "react";
import { StyledText } from "../../../assets/typography/typography";
import { PrimaryButton } from "../../../components/Buttons";
import { colors } from "../../../components/colors";
import { InLineLabel } from "../../../components/Label";
import { css } from "@emotion/react";
import { breakpoints } from "../../../components/breakpoints";

type UserRoleProps = {
  role: string;
  icon: React.ReactNode;
  isAssigned: boolean;
  editable: boolean;
  remove: () => void;
  add: () => void;
};

const wrapperStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  ${breakpoints.mobile} {
    justify-content: start;
    align-items: start;
    flex-direction: column;
  }
`;

const innerWrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const UserRole = ({
  role,
  icon,
  isAssigned,
  remove,
  add,
  editable,
}: UserRoleProps) => {
  return (
    <div css={wrapperStyle}>
      <div css={innerWrapperStyle}>
        <div
          className="d-flex align-items-center justify-content-center p-3"
          style={{
            backgroundColor: isAssigned ? colors.ctaLight : colors.ctaInactive,
            borderRadius: "4px",
          }}
        >
          <StyledText
            color={isAssigned ? colors.ctaMain : colors.textPrimary}
            className="bodyTextSemibold mb-0"
          >
            {icon}
          </StyledText>
        </div>
        <StyledText
          color={colors.textPrimary}
          className="bodyTextSemibold mb-0"
        >
          {role}
        </StyledText>
        {isAssigned && (
          <InLineLabel
            backgroundColor={colors.successLight}
            color={colors.successDark}
          >
            Assigned
          </InLineLabel>
        )}
      </div>
      {editable && (
        <>
          {isAssigned ? (
            <PrimaryButton
              type="button"
              hoverColor={colors.errorLight}
              color={colors.errorDark}
              backgroundColor="white"
              onClick={remove}
              className="w-fit"
            >
              Remove
            </PrimaryButton>
          ) : (
            <PrimaryButton
              type="button"
              hoverColor={colors.ctaLight}
              color={colors.ctaMain}
              backgroundColor="white"
              onClick={add}
              className="w-fit"
            >
              Add
            </PrimaryButton>
          )}
        </>
      )}
    </div>
  );
};
